<div
  class="upload-area bg-app-background-20 rounded-lg p-12 border-2 border-dashed border-app-primary-10/20 hover:border-app-primary-10/50 transition-colors cursor-pointer flex flex-col items-center justify-center gap-4"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  (click)="fileInput.click()">
  <div class="text-center text-app-primary-20 flex flex-col items-center gap-2">
    <i class="fa-solid fa-cloud-arrow-up text-3xl text-app-secondary-10"></i>
    <span class="text-sm">Ziehen Sie eine Datei hier rein oder klicken Sie hier, um eine Datei auszuwählen</span>
  </div>
  @if (maxFileSize) {
    <div class="text-center text-app-primary-20/60 text-sm">
      Die Maximalgröße für den Upload beträgt: {{(maxFileSize / 1024 / 1024).toFixed(1)}} MB
    </div>
  }

  <input
    #fileInput
    type="file"
    (change)="onFileSelected($event)"
    [accept]="allowedMimeTypes.join(',')"
    hidden/>

  @if (fileError) {
    <div class="error-message text-red-500 text-center text-sm font-medium">
      {{ fileError }}
    </div>
  }
</div>
